import { render, staticRenderFns } from "./comp_Home-HowToCreateMyBook.vue?vue&type=template&id=d8b7ec42&scoped=true&"
import script from "./comp_Home-HowToCreateMyBook.vue?vue&type=script&lang=js&"
export * from "./comp_Home-HowToCreateMyBook.vue?vue&type=script&lang=js&"
import style0 from "./comp_Home-HowToCreateMyBook.vue?vue&type=style&index=0&id=d8b7ec42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b7ec42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
